import PageTitleComponent from "../../components/PageTitle";
import UpdateProduct from "../../components/Products/Actions/UpdateProduct";

export default function UpdateProductScreen(){
return <div>
    <PageTitleComponent title="Update Product" />
    <UpdateProduct/>
</div>
}